import { useSelector } from 'react-redux';
import { Button } from '@radix-ui/themes';

import { SIGN_IN_STEPS } from '../contants';
import { useSignInContext } from '../formContext';
import styles from '../sign_in.module.css';
import { Header } from './Header.jsx';

export const UnknownEmployeeId = () => {
  const { setStep } = useSignInContext();
  const { employeeIdBody } = useSelector(state => state.demoData);

  return (
    <>
      <Header title="What's my Employee ID?" subtitle={employeeIdBody} />
      <Button
        size="3"
        variant="soft"
        mt="auto"
        className={styles.signInButton}
        onClick={() => setStep(SIGN_IN_STEPS.EMPLOYEE_ID)}
      >
        Back
      </Button>
    </>
  );
};
